// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-field[data-v-886a3ed2]{position:relative}.hidden-input[data-v-886a3ed2]{visibility:hidden;height:0;position:absolute;top:0}", ""]);
// Exports
module.exports = exports;
